export const bn = {
    'buttons': {
        'return': 'ফিরে যান'
    },
    'selects': {
        'currency': {
            'label': 'মুদ্রা',
            'placeholder': 'একটি মুদ্রা নির্বাচন করুন',
            'options-title': 'উপলব্ধ মুদ্রার তালিকা'
        },
        'currency-and-network': {
            'placeholder': 'একটি মুদ্রা এবং নেটওয়ার্ক নির্বাচন করুন',
            'options-title': 'উপলব্ধ মুদ্রার তালিকা'
        },
        'selected-label': 'নির্বাচিত: {selected} এর মধ্যে {length}',
        'search': 'অনুসন্ধান করুন',
        'errors': {
            'invalid': 'অবৈধ মান',
            'required': 'প্রয়োজনীয়',
            'card-holder': 'কার্ডধারীর প্রথম এবং শেষ নাম প্রবেশ করুন',
            'input-amount': 'পরিমাণ প্রবেশ করুন',
            'fill-card': 'কার্ডের তথ্য পূরণ করুন'
        },
        'empty-list': 'খালি তালিকা',
        'address': {
            'label': '{currency} এর উত্তোলনের ঠিকানা',
            'options-title': 'উপলব্ধ ঠিকানার তালিকা'
        },
        'cardholder-input': {
            'placeholder': 'কার্ডধারী'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'আপনার আমানতের ঠিকানা'
            },
            'invoice': {
                'address': 'ঠিকানা',
                'paid-amount': 'প্রদত্ত পরিমাণ'
            }
        }
    },
    'labels': {
        'deposit': 'অ্যাকাউন্টে টাকা জমা',
        'withdraw': 'উত্তোলন',
        'currency': 'মুদ্রা',
        'amount': 'পরিমাণ',
        'invoice': {
            'remaining-time': 'পরিশোধের জন্য অবশিষ্ট সময়',
            'status': {
                'expires': 'সময় শেষ',
                'success': 'পেমেন্ট সফল',
                'error': 'ত্রুটি'
            },
            'partially-paid': {
                'title': 'আংশিকভাবে পরিশোধিত',
                'info': 'পরিমাণ আংশিকভাবে পরিশোধিত হয়েছে। সফল পেমেন্টের জন্য অবশিষ্ট পরিমাণ প্রদান করতে হবে।'
            },
            'orphan': {
                'title': 'অরফান লেনদেন',
                'description': 'এই আদেশে লেনদেনগুলির মধ্যে একটি ভুল নেটওয়ার্ক বা মুদ্রা ধারণ করে।',
                'contact': 'ID সহ প্রযুক্তিগত সহায়তার সাথে যোগাযোগ করুন:'
            },
            'you-paid': 'আপনি পরিশোধ করেছেন',
            'active-order': 'সক্রিয় আদেশ',
            'new-invoice': 'নতুন ইনভয়েস',
            'order-id': 'ইনভয়েস আইডি',
            'payment-amount': 'পেমেন্টের পরিমাণ'
        },
        'continue': 'চালিয়ে যান',
        'payout': {
            'address': '{currency} এর উত্তোলনের ঠিকানা',
            'tag-or-memo': 'ট্যাগ বা মেমো',
            'status': {
                'processed': 'সফল',
                'error': 'ত্রুটি',
                'orphan': 'অরফান লেনদেন',
                'approve_rejected': 'প্রত্যাখ্যান',
                'in-progress': 'প্রক্রিয়াধীন',
                'need-approve': 'অনুমোদনের প্রয়োজন',
                'awaiting-confirmation': 'আপনার উত্তোলনের অনুরোধটি নিশ্চিতকরণের জন্য অপেক্ষা করছে'
            },
            'info': {
                'withdraw-id': 'উত্তোলনের আইডি',
                'tx-hash': 'ট্রানজেকশন হ্যাশ',
                'currency-and-network': 'মুদ্রা এবং নেটওয়ার্ক',
                'address': 'ঠিকানা',
                'tag-or-memo': 'ট্যাগ বা মেমো',
                'amount': 'উত্তোলনের পরিমাণ'
            }
        },
        'fiat': {
            'title': 'ফিয়াটের মাধ্যমে জমা',
            'info': {
                'amount': 'পরিমাণ',
                'date': 'পেমেন্টের তারিখ',
                'id': 'জমার আইডি',
                'system': 'পেমেন্ট সিস্টেম'
            },
            'status': {
                'new': 'নতুন',
                'pending': 'অপেক্ষমাণ',
                'authorized': 'অনুমোদিত',
                'confirmed': 'নিশ্চিত',
                'reconciled': 'সামঞ্জস্যপূর্ণ',
                'error': 'ত্রুটি',
                'declined': 'প্রত্যাখ্যান'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'ভুল উইজেট আইডি',
        'wrong-ext-user-id': 'ভুল বহিরাগত ব্যবহারকারী আইডি',
        '404': 'দুঃখিত! আমরা খুঁজেছি কিন্তু আপনি যা খুঁজছেন তা খুঁজে পাইনি।',
        'without-xt-user-id-withdrawal': 'উত্তোলন অপ্রাপ্য। extUserId প্যারামিটার প্রেরণ করা হয়নি',
        'without-xt-user-id-deposit': 'জমা অপ্রাপ্য। extUserId প্যারামিটার প্রেরণ করা হয়নি'
    },
    'invoice': {
        'order': 'অর্ডার',
        'inputs': {
            'email': {
                'label': 'ইমেল ঠিকানা',
                'placeholder': 'আপনার ইমেল ঠিকানা লিখুন'
            },
            'amount': {
                'label': 'পরিমাণ',
                'placeholder': 'পরিমাণ লিখুন'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'মার্কিন ডলারে পরিমাণ',
                'rate': 'বিনিময় হার',
                'payment-id': 'পেমেন্ট আইডি',
                'description': 'বিবরণ'
            }
        },
        'order-public-link': {
            'if-you-reload': 'যদি আপনি পৃষ্ঠাটি পুনরায় লোড করেন, ইনভয়েসের তথ্য হারিয়ে যাবে। ডেটা সংরক্ষণের জন্য,',
            'do-not-refresh': 'পৃষ্ঠাটি পুনরায় লোড করবেন না বা ইনভয়েসটি একটি',
            'new-tab': 'নতুন ট্যাবে খুলুন'
        },
        'statuses': {
            'ERROR': 'ত্রুটি',
            'PENDING': 'অপেক্ষমাণ',
            'PROCESSED': 'প্রক্রিয়াকৃত',
            'REJECTED': 'প্রত্যাখ্যাত',
            'OVERPAID': 'অতিরিক্ত অর্থ প্রদান করা হয়েছে',
            'CREATED': 'তৈরি করা হয়েছে',
            'PARTIAL': 'আংশিকভাবে পরিশোধিত',
            'INIT': 'আরম্ভিত',
            'EXPIRED': 'মেয়াদোত্তীর্ণ'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'জমা',
            'payment-history': 'পেমেন্ট ইতিহাস'
        },
        'payment-history': {
            'empty-label': 'আপনার প্রদত্ত ঠিকানায় প্রেরিত সমস্ত লেনদেন এখানে উপলব্ধ থাকবে',
            'headers': {
                'date': 'তারিখ এবং সময়',
                'amount': 'পরিমাণ',
                'tx': 'ট্রানজেকশন হ্যাশ',
                'status': 'অবস্থা'
            },
            'statuses': {
                'processed': 'প্রক্রিয়াকৃত',
                'pending': 'অপেক্ষমাণ',
                'rejected': 'প্রত্যাখ্যাত',
                'error': 'ত্রুটি'
            },
            'in': 'এ'
        },
        'qr-block': {
            'empty-label': 'ক্রিপ্টোকারেন্সি দিয়ে রিচার্জ',
            'qr-info-pre-invoice': 'শুধুমাত্র পাঠান',
            'qr-info-pre-personal': ' শুধুমাত্র কোন পরিমাণ পাঠান',
            'qr-info-post': 'এই ঠিকানায়',
            'qr-info-minimal': 'কম স্থানান্তর 1 মার্কিন ডলার জমা হয় না'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'ফিয়াটের মাধ্যমে জমা',
            'payment-history': 'পেমেন্ট ইতিহাস'
        },
        'labels': {
            'pay': 'পরিশোধ',
            'service-commission': 'সার্ভিস কমিশনের পরিমাণ',
            'total': 'মোট',
            'you-pay': 'আপনি প্রদান করছেন'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'অরফান লেনদেন',
            'info': 'এই আদেশে লেনদেনগুলির মধ্যে একটি ভুল নেটওয়ার্ক বা মুদ্রা ধারণ করে।',
            'support': 'ID সহ প্রযুক্তিগত সহায়তার সাথে যোগাযোগ করুন'
        }
    },
    'cookie-policy': {
        'by-clicking': '"চালিয়ে যান" বোতামে ক্লিক করলে আপনি স্বয়ংক্রিয়ভাবে সম্মতি জানাচ্ছেন',
        'our': 'আমাদের কুকি নীতির সাথে'
    },
    'payout': {
        'payout': 'পেমেন্ট',
        'output': 'উত্তোলন',
        'withdraw': 'উত্তোলন',
        'errors': {
            'wrong-address': 'ঠিকানাটি {network} নেটওয়ার্কের নয়'
        }
    }
}
